import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-exam-fee-students',
  templateUrl: './exam-fee-students.component.html',
  styleUrls: ['./exam-fee-students.component.scss']
})
export class ExamFeeStudentsComponent implements OnInit {
  APIService: any;
  studentGrid: any;
  Stu = [];
  constructor(
    public umsService: UmsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    const studentsWithNullTemplate = this.data.data.filter(record => record.TemplateCode === null);

    const studentsWithNonNullTemplate = this.data.data.filter(record => record.TemplateCode !== null);

    // Filter out students with non-null TemplateCode if there's a corresponding student with null TemplateCode
    const validStudents = studentsWithNullTemplate.filter(student => {
        const correspondingNonNullTemplateStudent = studentsWithNonNullTemplate.find(record => 
            record.StuNumber === student.StuNumber
        );
        return !correspondingNonNullTemplateStudent;
    });
    let StudentData = []
    StudentData = validStudents.concat(studentsWithNonNullTemplate);
    let rgNoMap = new Map<string, any>();
    StudentData.forEach(student => {
        // Store each student object with RgNo as the key (overwrite if key already exists)
        rgNoMap.set(student.RgNo, student);
      });
      
      // Convert the map back to an array of objects (if needed)
      this.studentGrid = Array.from(rgNoMap.values());
      
    // const invalidRecords = this.data.data.filter(record => record.TemplateCode !== null);
    // if (invalidRecords.length > 0) {
    //   this.Stu.push(...invalidRecords);
    //   this.studentGrid = this.Stu;
    // } else {
    //   this.studentGrid = this.data.data;
    // }
  }

}
